import React from 'react';

import { WizardCompletedPropsType } from './WizardCompleted.types';

export default function WizardCompleted({
  children,
}: WizardCompletedPropsType) {
  return <div>{children}</div>;
}
